<template>
  <div class="" style="position: relative">
    <call-to-action></call-to-action>
    <search id="search"></search>
    <carousel :autoplay="true" :autoplayTimeout="10000" :autoplayHoverPause="true" :perPage="1">
    <slide>
      <img src="@/assets/Public/banners/elephants.jpg" width="100%" alt="">
    </slide>
    <slide>
      <img src="@/assets/Public/banners/lioness.jpg" width="100%" alt="">
    </slide>
    <slide>
      <img src="@/assets/Public/banners/secretary.jpg" width="100%" alt="">
    </slide>
    <slide>
      <img src="@/assets/Public/banners/zebra.jpg" width="100%" alt="">
    </slide>
  </carousel>
  </div>
</template>

<script>
import Search from './Search.vue'
import CallToAction from './CallToAction'
export default {
  name: 'PublicMainSlider',
  data () {
    return {
    }
  },
  components: {
    CallToAction,
    Search
  }
}
</script>

<style>
  .select {
    margin-left: 2%;
    margin-top: 4%;
    width: 150px;
    height: 48px;
    box-sizing: border-box;
    display: block;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
  }
  #search {
    z-index: 1;
    position: absolute;
    top: 60%;
    margin-bottom: 50%;
    left: 15%;
    right: 15%;
/**/
    background-color: white;
  }
</style>
